import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CustomerId } from "@yalana/contracts";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

const searchSchema = z.object({
  customerId: CustomerId.optional(),
});

/**
 * @purpose Define a role's permissions
 * @primary Permission matrix form
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/roles/$id")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
